import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderAirlineList, getJobOrderAirportList, getJobOrderCurrencyList, getJobOrderCustomerList, getJobOrderFreightDetails, getJobOrderIncotermList, getJobOrderPortList, getJobOrderSeaportList, getJobOrderShiplineList } from '../../../../../Redux/action/Joborder/JoborderAction';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import InputTextJSX from './InputTextJSX';
import { customStyles } from '../../../../../HelperFunctions';
import { getFFAirExpConsigneeBranch, getFFAirExpConsigneeBranchBank, getFFAirExpOrganisation, getFFAirExpShipperBranch, getFFAirExpShipperBranchBank } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import TextAreaJSX from './TextAreaJSX';
import SelectReactJSX from './SelectReactJSX';
import RoutingTab from './Freight/RoutingTab';

const FreightAirTab = ({ token, user_id, b64id, transmode, iataAgentOptions }) => {

    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(true);
    const [disableSubmit, setDisableSubmit] = useState(false);

    // ---- Helper to get ordinal name from index (0-based) ----
    const getOrdinal = (n) => {
        const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];
        return ordinals[n] || `${n + 1}th`; // fallback for >10
    };

    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderShiplineList());
            dispatch(getJobOrderSeaportList());
            dispatch(getJobOrderAirportList());
            dispatch(getJobOrderPortList());
            dispatch(getJobOrderAirlineList());
            dispatch(getJobOrderCustomerList(token, user_id));
            dispatch(getJobOrderIncotermList());
            dispatch(getJobOrderCurrencyList());
            dispatch(getFFAirExpOrganisation(token, user_id));

            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderFreightDetails(token, user_id, id));
                }
            }
        }
    }, [token, user_id, b64id]);

    const refreshFreightData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderFreightDetails(token, user_id, id));
            }
        }
    }

    let {
        loadingJobOrderFreightDetail,
        JobOrderFreightDetailError,
        JobOrderFreightDetail,
        loadingJobOrderAirlineList,
        JobOrderAirlineList,
        JobOrderAirlineListError,
        loadingJobOrderShiplineList,
        JobOrderShiplineList,
        JobOrderShiplineListError,
        loadingJobOrderPortList,
        JobOrderPortList,
        JobOrderPortListError,
        loadingJobOrderAirportList,
        JobOrderAirportList,
        JobOrderAirportListError,
        loadingJobOrderSeaportList,
        JobOrderSeaportList,
        JobOrderSeaportListError,
        loadingJobOrderCustomerList,
        JobOrderCustomerList,
        JobOrderCustomerListError,
        loadingJobOrderIncotermList,
        JobOrderIncotermListError,
        JobOrderIncotermList,
        loadingJobOrderCurrencyList,
        JobOrderCurrencyListError,
        JobOrderCurrencyList,
        loadingJobOrderEntityDetail,
        JobOrderEntityDetail,
        JobOrderEntityDetailError,
        loadingJobOrderDetail,
        JobOrderDetail,
        JobOrderDetailError,
    } = useSelector(state => state?.JoborderReducer);

    const {
        loadingFFAirExpOrganisationList,
        FFAirExpOrganisationList,
        FFAirExpOrganisationListError,
        loadingFFAirExpShipperBranchList,
        FFAirExpShipperBranchList,
        FFAirExpShipperBranchListError,
        loadingFFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchListError,
        loadingFFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankListError,
        loadingFFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankListError,
    } = useSelector(state => state?.FFAirExpReducer);

    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (JobOrderCurrencyList) {
            let arr = [];
            JobOrderCurrencyList.map(val => arr.push({ value: val.id, label: `${val.currency}` }));
            setCurrencyOptions(arr);
        }
    }, [JobOrderCurrencyList]);
    console.log(currencyOptions)

    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (FFAirExpOrganisationList) {
            let arr = [];
            FFAirExpOrganisationList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.customerType})`, entity: val.entity_type ? JSON.parse(val.entity_type) : [] }));
            setOrganisationOptions(arr);
        }
    }, [FFAirExpOrganisationList]);

    const [airportOptions, setAirPortOptions] = useState([]);
    useEffect(() => {
        if (JobOrderAirportList) {
            let arr = [];
            JobOrderAirportList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setAirPortOptions(arr);
        }
    }, [JobOrderAirportList]);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);
    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);
    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    useEffect(() => {
        if (FFAirExpShipperBranchList) {
            let arr = [];
            FFAirExpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFAirExpShipperBranchList]);

    useEffect(() => {
        if (FFAirExpShipperBranchBankList) {
            let arr = [];
            FFAirExpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFAirExpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchList) {
            let arr = [];
            FFAirExpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirExpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchBankList) {
            let arr = [];
            FFAirExpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFAirExpConsigneeBranchBankList]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];
            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);

    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpShipperBranchBank(token, user_id, branch_id));
        }
    };
    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };

    // Initial value for flight segments - we will store as array
    const getInitialFlightSegments = () => {
        // Try to load from existing freight data if available
        // We need to check both the new structure (with freight) and the old one
        const freight = JobOrderFreightDetail?.freight || JobOrderFreightDetail;
        if (freight && freight.flight_segments) {
            try {
                const parsed = JSON.parse(freight.flight_segments);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) { console.error(e); }
        }
        // If not, create from old fields (max 2 segments)
        const segments = [];
        if (freight) {
            if (freight.to_one || freight.by_first_carrier || freight.flight_no_one || freight.flight_date_one) {
                segments.push({
                    airport_of_departure_id: freight.airport_of_departure_id || 0,
                    airport_of_departure_name: freight.airport_of_departure_name || "",
                    airport_of_destination_id: freight.airport_of_destination_id || 0,
                    airport_of_destination_name: freight.airport_of_destination_name || "",
                    to: freight.to_one || "",
                    by_first_carrier: freight.by_first_carrier || "",
                    to_second: freight.to_two || "",
                    by_second: freight.by_one || "",
                    to_third: freight.to_three || "",
                    by_third: freight.by_two || "",
                    flight_no: freight.flight_no_one || "",
                    flight_date: freight.flight_date_one || "",
                    cto: freight.cto || "",
                });
            }
            if (freight.flight_no_two || freight.flight_date_two) {
                segments.push({
                    airport_of_departure_id: 0,
                    airport_of_departure_name: "",
                    airport_of_destination_id: 0,
                    airport_of_destination_name: "",
                    to: "",
                    by_first_carrier: "",
                    to_second: "",
                    by_second: "",
                    to_third: "",
                    by_third: "",
                    flight_no: freight.flight_no_two || "",
                    flight_date: freight.flight_date_two || "",
                    cto: "",
                });
            }
        }
        if (segments.length === 0) {
            segments.push({
                airport_of_departure_id: 0,
                airport_of_departure_name: "",
                airport_of_destination_id: 0,
                airport_of_destination_name: "",
                to: "",
                by_first_carrier: "",
                to_second: "",
                by_second: "",
                to_third: "",
                by_third: "",
                flight_no: "",
                flight_date: "",
                cto: "",
            });
        }
        return segments;
    };

    const formik = useFormik({
        initialValues: {
            shipper_id: 0,
            shipper_branch_id: 0,
            shipper_branch_bank_account_id: 0,
            consignee_id: 0,
            consignee_branch_id: 0,
            consignee_branch_bank_account_id: 0,
            issuing_carrier_agent_id: 0,
            flight_segments: getInitialFlightSegments(),
            currency: "",
            chgs_code: "",
            wt_val: "",
            other: "",
            declared_value_for_carriage: "",
            declared_value_for_customs: "",
            amount_of_insurance: "",
            handling_info: "",
            port_of_loading: 0,
            port_of_discharge: 0,
            place_of_acceptance: "",
            place_of_delivery: "",
            vessel_and_voyage_no: "",
            freight_term: "",
            freight_payable_at: "",
            number_of_original_mdt: "",
            place_of_issue: "",
            place_of_date: "",
            notify_address: "",
            notify_email_address: "",
            delivery_of_goods_apply_to_address: "",
            delivery_of_goods_apply_to_email: "",
            delivery_of_goods_apply_to_tax_id: 0,
            delivery_of_goods_apply_to_zc: "",
        },
        onSubmit: (values) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                };
                values.job_order_id = atob(b64id);
                // Prepare old fields from first two segments for backward compatibility
                const segments = values.flight_segments;
                if (segments && segments.length > 0) {
                    const seg0 = segments[0];
                    values.airport_of_departure_id = seg0.airport_of_departure_id || 0;
                    values.airport_of_departure_name = seg0.airport_of_departure_name || "";
                    values.airport_of_destination_id = seg0.airport_of_destination_id || 0;
                    values.airport_of_destination_name = seg0.airport_of_destination_name || "";
                    values.to_one = seg0.to || "";
                    values.by_first_carrier = seg0.by_first_carrier || "";
                    values.to_two = seg0.to_second || "";
                    values.by_one = seg0.by_second || "";
                    values.to_three = seg0.to_third || "";
                    values.by_two = seg0.by_third || "";
                    values.flight_no_one = seg0.flight_no || "";
                    values.flight_date_one = seg0.flight_date || "";
                    values.cto = seg0.cto || "";
                }
                if (segments && segments.length > 1) {
                    const seg1 = segments[1];
                    values.flight_no_two = seg1.flight_no || "";
                    values.flight_date_two = seg1.flight_date || "";
                } else {
                    values.flight_no_two = "";
                    values.flight_date_two = "";
                }
                // Send flight_segments as an array (not stringified)
                // The backend should accept an array of objects
                values.flight_segments = values.flight_segments;
                axios.post(`${adminMainUrl}/api/jobOrder/freight/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshFreightData();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal Server Error!"
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg;
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (!loadingJobOrderEntityDetail && !loadingJobOrderFreightDetail) {
            const freight = JobOrderFreightDetail?.freight || JobOrderFreightDetail;

            // Priority: 1) saved freight value, 2) entity detail, 3) job order fields
            const freightShipperId = freight?.shipper_id ? Number(freight.shipper_id) : 0;
            const freightConsigneeId = freight?.consignee_id ? Number(freight.consignee_id) : 0;
            const entityShipperId = JobOrderEntityDetail?.shipper_customer_id ? Number(JobOrderEntityDetail.shipper_customer_id) : 0;
            const entityConsigneeId = JobOrderEntityDetail?.consignee_customer_id ? Number(JobOrderEntityDetail.consignee_customer_id) : 0;
            const jobShipperId = JobOrderDetail?.customer_id ? Number(JobOrderDetail.customer_id) : 0;
            const jobConsigneeId = JobOrderDetail?.consignee_id ? Number(JobOrderDetail.consignee_id) : 0;

            const resolvedShipper = freightShipperId || entityShipperId || jobShipperId;
            const resolvedConsignee = freightConsigneeId || entityConsigneeId || jobConsigneeId;

            if (resolvedShipper && (!formik.values.shipper_id || formik.values.shipper_id === 0)) {
                formik.setFieldValue("shipper_id", resolvedShipper);
                handleShipperBranch(resolvedShipper);
            }
            if (resolvedConsignee && (!formik.values.consignee_id || formik.values.consignee_id === 0)) {
                formik.setFieldValue("consignee_id", resolvedConsignee);
                handleConsigneeBranch(resolvedConsignee);
            }
        }
    }, [loadingJobOrderEntityDetail, loadingJobOrderFreightDetail, JobOrderEntityDetail, JobOrderFreightDetail, JobOrderDetail]);

    // Load freight details into formik
    useEffect(() => {
        if (loadingJobOrderFreightDetail) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };
        // Safely extract freight object from the new structure or use old one
        const freight = JobOrderFreightDetail?.freight || JobOrderFreightDetail;
        if (freight) {
            formik.setFieldValue("shipper_id", freight.shipper_id);
            if (freight.shipper_id) {
                dispatch(getFFAirExpShipperBranch(token, user_id, freight.shipper_id));
            }
            formik.setFieldValue("shipper_branch_id", freight.shipper_branch_id);
            if (freight.shipper_branch_id) {
                dispatch(getFFAirExpShipperBranchBank(token, user_id, freight.shipper_branch_id));
            }
            formik.setFieldValue("shipper_branch_bank_account_id", freight.shipper_branch_bank_account_id);
            formik.setFieldValue("consignee_id", freight.consignee_id);
            if (freight.consignee_id) {
                dispatch(getFFAirExpConsigneeBranch(token, user_id, freight.consignee_id));
            }
            formik.setFieldValue("consignee_branch_id", freight.consignee_branch_id);
            if (freight.consignee_branch_id) {
                dispatch(getFFAirExpConsigneeBranchBank(token, user_id, freight.consignee_branch_id));
            }
            formik.setFieldValue("consignee_branch_bank_account_id", freight.consignee_branch_bank_account_id);
            formik.setFieldValue("issuing_carrier_agent_id", freight.issuing_carrier_agent_id ?? 0);
            formik.setFieldValue("currency", freight.currency ? Number(freight.currency) : 0);
            formik.setFieldValue("chgs_code", freight.chgs_code);
            formik.setFieldValue("wt_val", freight.wt_val);
            formik.setFieldValue("other", freight.other);
            formik.setFieldValue("declared_value_for_carriage", freight.declared_value_for_carriage);
            formik.setFieldValue("declared_value_for_customs", freight.declared_value_for_customs);
            formik.setFieldValue("amount_of_insurance", freight.amount_of_insurance);
            formik.setFieldValue("handling_info", freight.handling_info);
            formik.setFieldValue("port_of_loading", freight.port_of_loading);
            formik.setFieldValue("port_of_discharge", freight.port_of_discharge);
            formik.setFieldValue("place_of_acceptance", freight.place_of_acceptance);
            formik.setFieldValue("place_of_delivery", freight.place_of_delivery);
            formik.setFieldValue("vessel_and_voyage_no", freight.vessel_and_voyage_no);
            formik.setFieldValue("freight_term", freight.freight_term);
            formik.setFieldValue("freight_payable_at", freight.freight_payable_at);
            formik.setFieldValue("number_of_original_mdt", freight.number_of_original_mdt);
            formik.setFieldValue("place_of_issue", freight.place_of_issue);
            formik.setFieldValue("place_of_date", freight.place_of_date);
            formik.setFieldValue("notify_address", freight.notify_address);
            formik.setFieldValue("notify_email_address", freight.notify_email_address);
            formik.setFieldValue("delivery_of_goods_apply_to_address", freight.delivery_of_goods_apply_to_address);
            formik.setFieldValue("delivery_of_goods_apply_to_email", freight.delivery_of_goods_apply_to_email);
            formik.setFieldValue("delivery_of_goods_apply_to_tax_id", freight.delivery_of_goods_apply_to_tax_id);
            formik.setFieldValue("delivery_of_goods_apply_to_zc", freight.delivery_of_goods_apply_to_zc);
        }

        // ---- Flight segments loading ----
        // First, check if the new structure provides flight_bookings array
        let segmentsToSet = null;
        if (JobOrderFreightDetail?.flight_bookings && Array.isArray(JobOrderFreightDetail.flight_bookings)) {
            // Map flight_bookings to the segment object structure expected by the form
            segmentsToSet = JobOrderFreightDetail.flight_bookings.map(booking => ({
                airport_of_departure_id: booking.airport_of_departure ? parseInt(booking.airport_of_departure) : 0,
                airport_of_departure_name: "", // we might not have the name, but we can keep it empty or fetch later
                airport_of_destination_id: booking.airport_of_destination ? parseInt(booking.airport_of_destination) : 0,
                airport_of_destination_name: "",
                to: booking.to_first || "",
                by_first_carrier: booking.by_first_carrier || "",
                to_second: booking.to_second || "",
                by_second: booking.by_second_carrier || "",
                to_third: "",
                by_third: "",
                flight_no: booking.flight_number || "",
                flight_date: booking.flight_date || "",
                cto: booking.cto || "",
            }));
        } else if (freight && freight.flight_segments) {
            // Old structure: flight_segments JSON string
            try {
                const parsed = JSON.parse(freight.flight_segments);
                if (Array.isArray(parsed)) {
                    segmentsToSet = parsed;
                }
            } catch (e) { console.error(e); }
        }

        if (segmentsToSet && segmentsToSet.length > 0) {
            formik.setFieldValue("flight_segments", segmentsToSet);
        } else {
            // Fallback to old fields from freight
            const segments = [];
            if (freight) {
                if (freight.to_one || freight.by_first_carrier || freight.flight_no_one) {
                    segments.push({
                        airport_of_departure_id: freight.airport_of_departure_id || 0,
                        airport_of_departure_name: freight.airport_of_departure_name || "",
                        airport_of_destination_id: freight.airport_of_destination_id || 0,
                        airport_of_destination_name: freight.airport_of_destination_name || "",
                        to: freight.to_one || "",
                        by_first_carrier: freight.by_first_carrier || "",
                        to_second: freight.to_two || "",
                        by_second: freight.by_one || "",
                        to_third: freight.to_three || "",
                        by_third: freight.by_two || "",
                        flight_no: freight.flight_no_one || "",
                        flight_date: freight.flight_date_one || "",
                        cto: freight.cto || "",
                    });
                }
                if (freight.flight_no_two) {
                    segments.push({
                        airport_of_departure_id: 0,
                        airport_of_departure_name: "",
                        airport_of_destination_id: 0,
                        airport_of_destination_name: "",
                        to: "",
                        by_first_carrier: "",
                        to_second: "",
                        by_second: "",
                        to_third: "",
                        by_third: "",
                        flight_no: freight.flight_no_two || "",
                        flight_date: freight.flight_date_two || "",
                        cto: "",
                    });
                }
            }
            if (segments.length === 0) {
                segments.push({
                    airport_of_departure_id: 0,
                    airport_of_departure_name: "",
                    airport_of_destination_id: 0,
                    airport_of_destination_name: "",
                    to: "",
                    by_first_carrier: "",
                    to_second: "",
                    by_second: "",
                    to_third: "",
                    by_third: "",
                    flight_no: "",
                    flight_date: "",
                    cto: "",
                });
            }
            formik.setFieldValue("flight_segments", segments);
        }
    }, [loadingJobOrderFreightDetail, JobOrderFreightDetailError, JobOrderFreightDetail]);

    // Helper functions for dynamic segments
    const addFlightSegment = () => {
        let segments = formik.values.flight_segments;
        if (!Array.isArray(segments)) segments = [];
        const newSegments = [...segments];
        newSegments.push({
            airport_of_departure_id: 0,
            airport_of_departure_name: "",
            airport_of_destination_id: 0,
            airport_of_destination_name: "",
            to: "",
            by_first_carrier: "",
            to_second: "",
            by_second: "",
            to_third: "",
            by_third: "",
            flight_no: "",
            flight_date: "",
            cto: "",
        });
        formik.setFieldValue("flight_segments", newSegments);
    };

    const removeFlightSegment = (index) => {
        let segments = formik.values.flight_segments;
        if (!Array.isArray(segments)) segments = [];
        const newSegments = [...segments];
        newSegments.splice(index, 1);
        formik.setFieldValue("flight_segments", newSegments);
    };

    // Safely get flight segments as array for rendering
    const flightSegments = Array.isArray(formik.values.flight_segments) ? formik.values.flight_segments : [];

    return (
        <>
            {showLoader ? <Beatloader /> :
                <div className="row-gap-2">
                    <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="Freight-shipping-tab" data-bs-toggle="pill" data-bs-target="#Freight-shipping" type="button" role="tab" aria-controls="Freight-shipping" aria-selected="true">Shipping Details</button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="Freight-shipping" role="tabpanel" aria-labelledby="Freight-shipping-tab">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <h4 className='mt-2'>Party Details</h4>
                                    {/* Shipper, Consignee etc. */}
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Shipper</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={shipperOrganisationOptions}
                                                    styles={customStyles}
                                                    name="shipper_id"
                                                    onChange={option => {
                                                        formik.setFieldValue("shipper_branch_id", "");
                                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                        setShipperBranchOptions([]);
                                                        setShipperBankOptions([]);
                                                        formik.setFieldValue('shipper_id', option.value);
                                                        handleShipperBranch(option.value);
                                                    }}
                                                    value={shipperOrganisationOptions.find(option => option.value == formik.values.shipper_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Shipper Branch</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={shipperBranchOptions}
                                                    styles={customStyles}
                                                    name="shipper_branch_id"
                                                    onChange={option => {
                                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                        setShipperBankOptions([]);
                                                        formik.setFieldValue('shipper_branch_id', option.value);
                                                        handleShipperBanks(option.value);
                                                    }}
                                                    value={shipperBranchOptions.find(option => option.value == formik.values.shipper_branch_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Shipper Branch Account No.</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={shipperBankOptions}
                                                    styles={customStyles}
                                                    name="shipper_branch_bank_account_id"
                                                    onChange={option => formik.setFieldValue('shipper_branch_bank_account_id', option.value)}
                                                    value={shipperBankOptions.find(option => option.value == formik.values.shipper_branch_bank_account_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Consignee</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={consigneeOrganisationOptions}
                                                    styles={customStyles}
                                                    name="consignee_id"
                                                    onChange={option => {
                                                        setConsigneeBranchOptions([]);
                                                        setConsigneeBankOptions([]);
                                                        formik.setFieldValue("consignee_branch_id", "");
                                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                        formik.setFieldValue('consignee_id', option.value);
                                                        handleConsigneeBranch(option.value);
                                                    }}
                                                    value={consigneeOrganisationOptions.find(option => option.value == formik.values.consignee_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Consignee Branch</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={consigneeBranchOptions}
                                                    styles={customStyles}
                                                    name="consignee_branch_id"
                                                    onChange={option => {
                                                        setConsigneeBankOptions([]);
                                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                        formik.setFieldValue('consignee_branch_id', option.value);
                                                        handleConsigneeBanks(option.value);
                                                    }}
                                                    value={consigneeBranchOptions.find(option => option.value == formik.values.consignee_branch_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Consignee Branch Account No.</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={consigneeBankOptions}
                                                    styles={customStyles}
                                                    name="consignee_branch_bank_account_id"
                                                    onChange={option => formik.setFieldValue('consignee_branch_bank_account_id', option.value)}
                                                    value={consigneeBankOptions.find(option => option.value == formik.values.consignee_branch_bank_account_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>IATA Agent</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={iataAgentOptions}
                                                    styles={customStyles}
                                                    name="issuing_carrier_agent_id"
                                                    onChange={option => formik.setFieldValue('issuing_carrier_agent_id', option.value)}
                                                    value={iataAgentOptions.find(option => option.value == formik.values.issuing_carrier_agent_id) || null}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className='mt-4'>Flight Booking / Routing</h4>
                                    <div className="row">
                                        {flightSegments.map((segment, idx) => (
                                            <div key={idx} className="border rounded p-3 mb-3 position-relative">
                                                {idx > 0 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary position-absolute top-0 end-0 mt-2 me-2"
                                                        onClick={() => removeFlightSegment(idx)}
                                                        style={{ zIndex: 1, padding: '0 8px', lineHeight: '1.5', borderRadius: '4px' }}
                                                    >
                                                        −
                                                    </button>
                                                )}
                                                <div className="row g-2">
                                                    {/* Row 1: Airport of Departure & Destination (2 cols) */}
                                                    <div className="col-md-6">
                                                        <label className="form-label mb-0">Airport of Departure</label>
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name={`flight_segments.${idx}.airport_of_departure_id`}
                                                            onChange={(option) => {
                                                                formik.setFieldValue(`flight_segments.${idx}.airport_of_departure_id`, option.value);
                                                                formik.setFieldValue(`flight_segments.${idx}.airport_of_departure_name`, option.label);
                                                            }}
                                                            value={airportOptions.find(option => option.value === segment.airport_of_departure_id) || null}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label mb-0">Airport of Destination</label>
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name={`flight_segments.${idx}.airport_of_destination_id`}
                                                            onChange={(option) => {
                                                                formik.setFieldValue(`flight_segments.${idx}.airport_of_destination_id`, option.value);
                                                                formik.setFieldValue(`flight_segments.${idx}.airport_of_destination_name`, option.label);
                                                            }}
                                                            value={airportOptions.find(option => option.value === segment.airport_of_destination_id) || null}
                                                        />
                                                    </div>

                                                    {/* Row 2: To, By First Carrier, To, By (4 cols) */}
                                                    <div className="col-md-3">
                                                        <label className="form-label mb-0">To</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.to`}
                                                            value={segment.to}
                                                            onChange={formik.handleChange}
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        {/* Dynamic label: By First Carrier, By Second Carrier, etc. */}
                                                        <label className="form-label mb-0">By {getOrdinal(idx)} Carrier</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.by_first_carrier`}
                                                            value={segment.by_first_carrier}
                                                            onChange={formik.handleChange}
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label mb-0">To</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.to_second`}
                                                            value={segment.to_second}
                                                            onChange={formik.handleChange}
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        {/* Dynamic label: By Second Carrier, By Third Carrier, etc. */}
                                                        <label className="form-label mb-0">By
                                                            {/* {getOrdinal(idx+1)} Carrier */}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.by_second`}
                                                            value={segment.by_second}
                                                            onChange={formik.handleChange}
                                                            maxLength={100}
                                                        />
                                                    </div>

                                                    {/* Row 3: Flight Number, Flight Date, CTO (3 cols) */}
                                                    <div className="col-md-4">
                                                        <label className="form-label mb-0">Flight Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.flight_no`}
                                                            value={segment.flight_no}
                                                            onChange={formik.handleChange}
                                                            maxLength={15}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label mb-0">Flight Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.flight_date`}
                                                            value={segment.flight_date}
                                                            onChange={formik.handleChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label mb-0">CTO</label>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name={`flight_segments.${idx}.cto`}
                                                            value={segment.cto}
                                                            onChange={formik.handleChange}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="DCSC">DCSC</option>
                                                            <option value="CELEBI">CELEBI</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-12 text-end">
                                            <button type="button" className="btn btn-sm btn-primary" onClick={addFlightSegment}>
                                                <i className="fas fa-plus"></i> Add More Flight
                                            </button>
                                        </div>
                                    </div>

                                    <h4 className='mt-2'>Charge Declaration</h4>
                                    <SelectReactJSX
                                        labelText={"Currency"}
                                        nameValue={"currency"}
                                        onChange={(option) => { formik.setFieldValue("currency", option.value) }}
                                        options={currencyOptions}
                                        value={currencyOptions.find(option => option.value == formik.values.currency) || null}
                                    />
                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>CHGS CODE</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <select className="form-control form-control-sm" id="chgs_code" name="chgs_code" value={formik.values.chgs_code} onChange={formik.handleChange}>
                                                    <option value="" disabled>-Select an option-</option>
                                                    <option value="PP">PP</option>
                                                    <option value="PC">PC</option>
                                                    <option value="CP">CP</option>
                                                    <option value="CC">CC</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Wt/Val(P/C)</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <select className="form-control form-control-sm" id="wt_val" name="wt_val" value={formik.values.wt_val} onChange={formik.handleChange}>
                                                    <option value="" disabled>-Select an option-</option>
                                                    <option value="P">P</option>
                                                    <option value="C">C</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>Other(P/C)</label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <select className="form-control form-control-sm" id="other" name="other" value={formik.values.other} onChange={formik.handleChange}>
                                                    <option value="" disabled>-Select an option-</option>
                                                    <option value="P">P</option>
                                                    <option value="C">C</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <InputTextJSX labelText={"Declared Value for Carriage"} nameValue={"declared_value_for_carriage"} value={formik.values.declared_value_for_carriage} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Declared Value for Customs"} nameValue={"declared_value_for_customs"} value={formik.values.declared_value_for_customs} onChange={formik.handleChange} />
                                    <InputTextJSX labelText={"Amount of Insurance"} nameValue={"amount_of_insurance"} value={formik.values.amount_of_insurance} onChange={formik.handleChange} />
                                    <TextAreaJSX labelText="Handeling Info" nameValue="handling_info" value={formik.values.handling_info} onChange={formik.handleChange} maxLength={250} />
                                </div>
                                <div className="row d-flex justify-content-end mt-2">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="tab-pane fade" id="Freight-routing" role="tabpanel" aria-labelledby="Freight-routing-tab">
                            <RoutingTab />
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default FreightAirTab;
